import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { appConfig, brand } from './lib/env.js';
import { initializeAnalytics } from './lib/analytics/index.js';
import { createAppRouter } from './router.js';
import './styles.css';

const root = document.getElementById('root');
const favicon = document.querySelector<HTMLLinkElement>('#brand-favicon');
if (!root || !favicon) {
  throw new Error('The planner root or favicon is missing from index.html');
}
document.title = appConfig.plannerTitle;
favicon.href = brand.logos.favicon;

const queryClient = new QueryClient();
initializeAnalytics();
const router = createAppRouter();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
